import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { getSessionStorageItem } from 'src/app/utils/browser-storage';

@Component({
    selector: 'app-registry-link',
    templateUrl: './registry-link.component.html',
    styleUrls: ['./registry-link.component.scss'],
    standalone: false
})
export class RegistryLinkComponent implements OnInit {

  userEmail: string | null = null;

  constructor(private router: Router) {}

  ngOnInit(): void {
    const nav = this.router.getCurrentNavigation();
    this.userEmail = nav?.extras?.state?.['userEmail']
                  ?? getSessionStorageItem('pendingRegistrationEmail');
  }

}
